module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_0_null@3x.3c5f39f9.png";